import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList, useObject } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { firebase_add_min_pressure_to_database, firebase_add_vaporizer_to_database, firebase_add_vaporizer_sensor_info_to_database,
firebase_add_gas_active_to_database, firebase_delete_gas_active_command_from_database, firebase_add_gas_leakage_count_to_database, firebase_add_device_management_to_database} from "./firebase";

import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import BlockIcon from '@mui/icons-material/Block';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Box from '@mui/material/Box';

function AdminTools(props){

  const history = useHistory();

  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    setIsAdmin(sessionStorage.getItem("admin")=="true");
  }, []);

if (!isAdmin)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <IconButton onClick={() => history.goBack()}>
                    <BlockIcon />
                </IconButton>
                Authorized user only...
              </Typography>
            </Box>
            </div>);
  }
  
  return (<div className="container" style={{height: '100%'}}>  
            <Container maxWidth="lg" >
               <Grid container spacing={2} sx={{pt: 12, pl:2, pr:2, pb:2}}>
                   <Grid item xs={12}>
                       <Paper elevation={2}>
                       <TableContainer component={Paper}>
                          <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <TableCell>Function Description [Proceed with caution!!!!]</TableCell>
                                <TableCell align="right">Run</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    Add min pressure limit
                                  </TableCell>
                                  <TableCell align="right">
                                    <Button variant="contained" onClick={() => {
                                      firebase_add_min_pressure_to_database();
                                    }}>Go</Button>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    Add vaporizer to device's current status
                                  </TableCell>
                                  <TableCell align="right">
                                    <Button variant="contained" onClick={() => {
                                      firebase_add_vaporizer_to_database();
                                    }}>Go</Button>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    Add vaporizer sensor info
                                  </TableCell>
                                  <TableCell align="right">
                                    <Button variant="contained" onClick={() => {
                                      firebase_add_vaporizer_sensor_info_to_database();
                                    }}>Go</Button>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    Add gas_active field
                                  </TableCell>
                                  <TableCell align="right">
                                    <Button variant="contained" onClick={() => {
                                      firebase_add_gas_active_to_database();
                                    }}>Go</Button>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    Add gas_leakage_count field
                                  </TableCell>
                                  <TableCell align="right">
                                    <Button variant="contained" onClick={() => {
                                      firebase_add_gas_leakage_count_to_database();
                                    }}>Go</Button>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    Add device_management field
                                  </TableCell>
                                  <TableCell align="right">
                                    <Button variant="contained" onClick={() => {
                                      firebase_add_device_management_to_database();
                                    }}>Go</Button>
                                  </TableCell>
                                </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                       </Paper>
                   </Grid>
               </Grid>
                   <Grid container spacing={2} sx={{p: 4}}>
                   <Grid item xs={12}></Grid> 
               </Grid>
                      </Container>
          
          </div>);
}

export default AdminTools;
